import Immutable from 'immutable';
import memoize from 'memoize-one';
import { bool, func, oneOfType, string } from 'prop-types';
import { Component } from 'react';
import { list, map } from 'react-immutable-proptypes';

import TargetMarketAutocomplete from 'components/ui/autocomplete/target-market';

import AuthFormSelectWrapper from './select-wrapper';

class AuthFormTargetMarket extends Component<{
  formKey: string;
  onChange: Function;
  value?: Immutable.Map<string, any>;
  error?: boolean | Immutable.List<any>;
  disabled?: boolean;
  errorMessage?: string;
}> {
  static propTypes = {
    formKey: string.isRequired,
    value: map,
    error: oneOfType([bool, list]),
    errorMessage: string,
    disabled: bool,
    onChange: func.isRequired,
  };

  onSelect = ({ label, id }) => {
    const { formKey, onChange, disabled } = this.props;
    if (disabled) {
      return;
    }
    onChange({ formKey, value: Immutable.Map({ label, id }) });
  };

  onUnselect = () => {
    const { formKey, onChange, disabled } = this.props;
    if (disabled) {
      return;
    }
    onChange({ formKey });
  };

  getValue = memoize((value) =>
    Immutable.Map.isMap(value) ? [value.toJS()] : [],
  );

  render() {
    const { formKey, value, error, errorMessage, disabled } = this.props;
    return (
      <AuthFormSelectWrapper error={error} errorMessage={errorMessage}>
        <TargetMarketAutocomplete
          id={`auth-form-target-market-${formKey}`}
          value={this.getValue(value)}
          onSelect={this.onSelect}
          onUnselect={this.onUnselect}
          disabled={disabled}
          searchOnClick
        />
      </AuthFormSelectWrapper>
    );
  }
}

export default AuthFormTargetMarket;
